module.exports = __webpack_public_path__ + "img/phone.238b6ba9.png";